export enum CompilationRequestType {
    FreeWall = "freewall",
    Dashboard = "dashboard"
}
